/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Collapse,
  List,
  Tabs,
  Tab,
  Link as MLink,
} from '@material-ui/core';
import { useHistory, Link } from 'react-router-dom';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Add from '@material-ui/icons/Add';
import { Observer } from 'mobx-react';
import { useRootStore } from '../../stores/BridgeProvider';
import { COLORS } from '../../components/util/Colors';
import Logo from '../../assets/DEAL MAP-LOGO.png';
import permissionCheck from '../../components/util/PermCheck';
import { NewsFeed } from '../../alerts/NewsFeed';
import HelpButton from '../../components/util/HelpButton';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 0,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  container: {
    flexGrow: 1,
  },
  title: {
    textDecoration: 'none',
    cursor: 'pointer',
    width: 'fit-content',
  },
  navLeft: {
    display: 'flex',
    marginRight: 'auto',
    alignItems: 'center',
  },
  navRight: {
    display: 'flex',
    alignItems: 'center',
  },
  leftDrop: {
    marginLeft: '20px',
  },
  nestedLink: {
    color: '#546e7a',
    fontSize: '12px',
    paddingLeft: '23px',
    paddingRight: '9px',
  },
  navContainer: {
    display: 'flex',
    padding: '0 24px',
  },
}));

const NestedMenuItem = ({ label, children, isLast }) => {
  const [subOpen, setSubOpen] = useState(false);

  const handleClick = e => {
    e.stopPropagation();
    setSubOpen(prev => !prev);
  };

  return (
    <div>
      <MenuItem button onClick={e => handleClick(e)} divider={!isLast}>
        {label}
        {subOpen ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={subOpen} timeout="auto">
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </div>
  );
};

/* Nav Tab Start */

const NavTab = ({ navItems, children, menuPerms, ...tabProps }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const noValidPermItems = permList =>
    permList.every(val => !permissionCheck(val));

  if (menuPerms && noValidPermItems(menuPerms)) return null;
  return (
    <div style={{ display: 'flex' }}>
      <Tab onClick={handleMenu} {...tabProps} style={{ padding: '20px 0' }} />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        onClose={handleClose}
      >
        {navItems && navItems({ handleClose })}
        {children}
      </Menu>
    </div>
  );
};

/* Nav Tab End */

const NavDropdown = ({ title, navItems, children, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const { arrow, titleStyle } = props;
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="nav-dropdown" style={{ alignSelf: 'center' }}>
      <Typography
        onClick={handleMenu}
        className={classes.title}
        variant="h4"
        color="inherit"
        style={{
          display: 'flex',
          alignItems: 'center',
          ...titleStyle,
        }}
      >
        {title}
        {arrow && <ArrowDropDown style={{ marginLeft: '5px' }} />}
      </Typography>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        onClose={handleClose}
      >
        {navItems && navItems({ handleClose })}
        {children}
      </Menu>
    </div>
  );
};

const Nav = () => (
  <Observer
    render={() => {
      const history = useHistory();
      const { authStore, orgStore } = useRootStore();
      const { settings } = orgStore;
      const classes = useStyles();
      const [value, setValue] = useState('Deals');

      const pathCheck = () => {
        const path = window.location.pathname.split('/')[1];

        const dealsArr = [
          'deal',
          'deals',
          'dashboard',
          'deal-mapper',
          'deal-template',
          'deal-templates',
          'reports',
        ];
        const accntArr = ['vouchers', 'payments'];
        const orgArr = [
          'user-management',
          'organization',
          'contacts',
          'accounts',
          'transaction-categories',
          'payment-types',
          'ext-sys-mapper',
          'transaction-category-mapper',
        ];
        if (dealsArr.some(x => x === path)) {
          return 'Deals';
        }
        if (accntArr.some(x => x === path)) {
          return 'Accounting';
        }
        if (orgArr.some(x => x === path)) {
          return 'Organization';
        }
        return false;
      };

      useEffect(() => {
        const currentPath = pathCheck();
        setValue(currentPath);
      }, [window.location.pathname]);

      const logout = () => {
        authStore.logout();
        window.sessionStorage.clear();
      };

      const goToRoute = route => {
        history.push(route);
      };

      return (
        <div className={classes.root}>
          <AppBar
            position="static"
            style={{ background: COLORS.midnight }}
            className="dmStep3 dmStep4"
          >
            <div className={classes.navContainer}>
              {settings && (
                <Fragment>
                  <div className={classes.navLeft}>
                    <img
                      src={Logo}
                      height="30px"
                      style={{ cursor: 'pointer', marginRight: '18px' }}
                      alt="Deal Map Logo"
                      onClick={() => goToRoute('/dashboard')}
                    />
                    <Tabs
                      value={value}
                      TabIndicatorProps={{
                        style: { background: '#FCFBFE' },
                      }}
                    >
                      <NavTab
                        value="Deals"
                        label={
                          <Typography
                            className={classes.title}
                            variant="h4"
                            color="inherit"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              textTransform: 'none',
                            }}
                          >
                            Deals
                            <ArrowDropDown style={{ marginLeft: '5px' }} />
                          </Typography>
                        }
                        navItems={({ handleClose }) => (
                          <div>
                            <MenuItem
                              component={Link}
                              onClick={() => handleClose()}
                              to="/deals"
                              divider
                            >
                              Deals
                            </MenuItem>
                            <MenuItem
                              component={Link}
                              to="/dashboard"
                              divider
                              onClick={() => handleClose()}
                            >
                              Dashboard
                            </MenuItem>
                            {permissionCheck('DM_M') && (
                              <MenuItem
                                component={Link}
                                to="/deal-mapper"
                                divider
                                onClick={() => handleClose()}
                              >
                                Deal Mapper
                              </MenuItem>
                            )}
                            {permissionCheck('DEALTEMP_M') && (
                              <MenuItem
                                component={Link}
                                to="/deal-templates"
                                divider
                                onClick={() => handleClose()}
                              >
                                Deal Templates
                              </MenuItem>
                            )}
                            {permissionCheck('DEAL_S') && (
                              <MenuItem
                                component={Link}
                                to="/reports"
                                onClick={() => handleClose()}
                              >
                                Reports
                              </MenuItem>
                            )}
                          </div>
                        )}
                      />
                      <NavTab
                        label={
                          <Typography
                            className={classes.title}
                            variant="h4"
                            color="inherit"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              textTransform: 'none',
                            }}
                          >
                            Accounting
                            <ArrowDropDown style={{ marginLeft: '5px' }} />
                          </Typography>
                        }
                        value="Accounting"
                        menuPerms={['VOUCHER_S', 'PAY_I']}
                        navItems={({ handleClose }) => (
                          <div>
                            {permissionCheck('VOUCHER_S') && (
                              <MenuItem
                                component={Link}
                                to="/vouchers"
                                divider
                                onClick={() => handleClose()}
                              >
                                Transactions
                              </MenuItem>
                            )}
                            {permissionCheck('PAY_I') && (
                              <MenuItem
                                component={Link}
                                to="/payments"
                                divider
                                onClick={() => handleClose()}
                              >
                                Invoice Payments
                              </MenuItem>
                            )}
                            <NestedMenuItem label="Account Setup" isLast>
                              <MenuItem
                                className={classes.nestedLink}
                                component={Link}
                                to="/accounts"
                                divider
                                onClick={() => handleClose()}
                              >
                                Financial Accounts
                              </MenuItem>
                              <MenuItem
                                className={classes.nestedLink}
                                component={Link}
                                to="/transaction-categories"
                                divider
                                onClick={() => handleClose()}
                              >
                                Transaction Categories
                              </MenuItem>
                              <MenuItem
                                component={Link}
                                to="/payment-types"
                                className={classes.nestedLink}
                                onClick={() => handleClose()}
                              >
                                Payment Types
                              </MenuItem>
                            </NestedMenuItem>
                            {/* <MenuItem
                              component={Link}
                              to="/"
                              onClick={() => handleClose()}
                            >
                              Journals
                            </MenuItem> */}
                          </div>
                        )}
                      />
                      <NavTab
                        label={
                          <Typography
                            className={classes.title}
                            variant="h4"
                            color="inherit"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              textTransform: 'none',
                            }}
                          >
                            {settings.Name}
                            <ArrowDropDown style={{ marginLeft: '5px' }} />
                          </Typography>
                        }
                        value="Organization"
                        navItems={({ handleClose }) => (
                          <div>
                            {permissionCheck('USER_M') && (
                              <MenuItem
                                component={Link}
                                to="/user-management"
                                divider
                                onClick={() => handleClose()}
                              >
                                {'Security & Users'}
                              </MenuItem>
                            )}

                            {permissionCheck('ORG_M') && (
                              <MenuItem
                                component={Link}
                                to="/organization"
                                divider
                                onClick={() => handleClose()}
                              >
                                Organization Settings
                              </MenuItem>
                            )}
                            <MenuItem
                              component={Link}
                              to="/contacts"
                              onClick={() => handleClose()}
                            >
                              Contacts
                            </MenuItem>
                          </div>
                        )}
                      />
                    </Tabs>
                  </div>

                  <NavDropdown
                    title={
                      <IconButton color="inherit">
                        <Add />
                      </IconButton>
                    }
                    navItems={({ handleClose }) => (
                      <div>
                        {permissionCheck('DEAL_I') && (
                          <MenuItem
                            component={Link}
                            to="/deals/new"
                            divider
                            onClick={() => handleClose()}
                          >
                            New Deal
                          </MenuItem>
                        )}
                        {permissionCheck('VOUCHER_I') && (
                          <MenuItem
                            component={Link}
                            divider
                            to="/vouchers/new"
                            onClick={() => handleClose()}
                          >
                            New Transaction
                          </MenuItem>
                        )}
                        {permissionCheck('CONTACT_I') && (
                          <MenuItem
                            component={Link}
                            to="/contacts/new"
                            onClick={() => handleClose()}
                          >
                            New Contact
                          </MenuItem>
                        )}
                      </div>
                    )}
                  />
                </Fragment>
              )}
              {/* Right side nav items Start */}
              <div
                className={classes.navRight}
                style={
                  !settings ? { marginLeft: 'auto', padding: '8px 0' } : null
                }
              >
                <NewsFeed />
                <HelpButton />
                <NavDropdown
                  title={
                    <IconButton color="inherit">
                      <AccountCircle />
                    </IconButton>
                  }
                  navItems={({ handleClose }) => (
                    <div>
                      {settings && (
                        <MenuItem
                          component={Link}
                          to="/profile/settings"
                          divider
                          onClick={() => handleClose()}
                        >
                          Profile
                        </MenuItem>
                      )}
                      <MenuItem
                        component={Link}
                        to="/select-organization"
                        divider
                        onClick={() => {
                          handleClose();
                          window.sessionStorage.removeItem('userNotified');
                        }}
                      >
                        Change Organization
                      </MenuItem>
                      <MenuItem
                        component={MLink}
                        href="https://dealmap.com/pricing"
                        divider
                        target="_blank"
                        rel="noopener"
                      >
                        Subscriptions
                      </MenuItem>
                      <MenuItem onClick={logout}>Log Out</MenuItem>
                    </div>
                  )}
                />
              </div>
              {/* Right side nav items End */}
            </div>
          </AppBar>
        </div>
      );
    }}
  />
);

export default Nav;
